import React from 'react';
import Title from '../../typography/title';

import styles from './NewSizeGuide.module.scss';
import { ResponsiveImage } from '../../atoms/image/ResponsiveImage';
import clsx from 'clsx';
import { Image } from '../../atoms/image/Image';

export const Measure = ({ data, isPDP, isMobile }) => {
  const { measureMedia, measureTitle, measureOptions } = data;

  return (
    <div className={clsx(styles.measureWrap, { [styles.measureWrapPDP]: isPDP })}>
      {(!isPDP && !isMobile) && (
        <Title align="left" className={styles.measureTitle}>
          {measureTitle}
        </Title>
      )}
      {measureMedia?.media && (
        <div className={styles.measureMedia}>
          {measureMedia?.media?.file?.includes('/media.')
            ? (
              <ResponsiveImage
                title="measure image"
                source={measureMedia}
              />
            )
            : (
              <Image
                alt={measureMedia?.name}
                title={measureMedia?.name}
                itemProp="image"
                image={measureMedia?.media?.file}
              />
            )}
        </div>
      )}
      {(isPDP || isMobile) && (
        <Title align="left" className={styles.measureTitle}>
          {measureTitle}
        </Title>
      )}
      {(measureOptions?.length > 0 && (measureOptions?.[0].optionText || measureOptions?.[0].optionTitle)) && (
        <div className={styles.measureOptions}>
          <ul>
            {measureOptions?.map((option, key) => (
              <li key={key}>
                <span className={styles.dots}>{key + 1}</span>
                <span>{option.optionTitle}</span>
                <p>{option.optionText}</p>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
};
